import React from 'react';
import PackageCard from '../components/PackageCard';
import { Helmet } from 'react-helmet-async';
const IntensiveLessonsPage = () => {
  const intensivePackages = [{
    title: '10 Hour Intensive',
    price: '£480',
    originalPrice: '£500',
    description: '£48 per hour - Perfect for those with some driving experience who need to quickly prepare for their test.',
    features: ['Save £20 on standard pricing', 'Concentrated learning', 'Quick skill development', 'Ideal for refresher training'],
    saving: '£20',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '20 Hour Intensive',
    price: '£910',
    originalPrice: '£1000',
    description: '£45.50 per hour - Complete your training in a condensed timeframe with our popular mid-range intensive course.',
    features: ['Save £90 on standard pricing', 'Accelerated learning programme', 'Comprehensive skill coverage', 'Ideal for quick test preparation'],
    saving: '£90',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '34 Hour Intensive',
    price: '£1,496',
    originalPrice: '£1,700',
    description: '£44 per hour - Our comprehensive course for those with little to no driving experience.',
    features: ['Save £204 on standard pricing', 'Complete beginner to test-ready', 'All driving skills covered', 'Theory test preparation included'],
    popular: true,
    saving: '£204',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '40 Hour Intensive',
    price: '£1,720',
    originalPrice: '£2,000',
    description: '£43 per hour - Our most comprehensive intensive course for complete beginners.',
    features: ['Save £280 on standard pricing', 'Complete driver training', 'Fast-track to test readiness', 'Additional practice on challenging skills'],
    saving: '£280',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  return <div className="bg-white" data-id="element-1427">
      <Helmet data-id="element-1428">
        <title data-id="element-1429">Intensive Driving Courses Northampton | Pass Quickly</title>
        <meta name="description" content="Fast-track your driving journey with intensive driving courses in Northampton. Flexible packages from 10 to 40 hours. Book online today." data-id="element-1430" />
        <meta name="keywords" content="intensive driving courses Northampton, crash driving courses Northampton, fast pass driving lessons Northampton, quick driving test Northampton" data-id="element-1431" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-1432">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1433">
          Intensive Driving Courses
        </h1>
        <h2 className="sr-only" data-id="element-1434">Fast Pass Driving Courses Northampton</h2>
        <h2 className="sr-only" data-id="element-1435">Accelerated Driving Lessons Northampton</h2>
        <h2 className="sr-only" data-id="element-1436">
          Pass Your Driving Test Quickly in Northampton
        </h2>
        <div className="mb-8" data-id="element-1437">
          <p className="text-gray-700" data-id="element-1438">
            Our intensive driving courses are designed for those who want to
            pass their test quickly. These condensed programmes offer the same
            high-quality instruction as our standard lessons but in a more
            concentrated format.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-1439">
          {intensivePackages.map((pkg, index) => <PackageCard key={index} {...pkg} data-id="element-1440" />)}
        </div>
        <div className="bg-gray-50 rounded-lg p-8 mb-12" data-id="element-1441">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1442">
            Is an Intensive Course Right for You?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1443">
            <div data-id="element-1444">
              <h3 className="text-xl font-semibold mb-3" data-id="element-1445">Benefits</h3>
              <ul className="space-y-2" data-id="element-1446">
                <li className="flex" data-id="element-1447">
                  <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1448">
                    ✓
                  </div>
                  <div data-id="element-1449">Faster route to passing your test</div>
                </li>
                <li className="flex" data-id="element-1450">
                  <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1451">
                    ✓
                  </div>
                  <div data-id="element-1452">
                    Consistent learning without long gaps between lessons
                  </div>
                </li>
                <li className="flex" data-id="element-1453">
                  <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1454">
                    ✓
                  </div>
                  <div data-id="element-1455">Cost savings compared to individual lessons</div>
                </li>
                <li className="flex" data-id="element-1456">
                  <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1457">
                    ✓
                  </div>
                  <div data-id="element-1458">Dedicated instructor throughout your course</div>
                </li>
                <li className="flex" data-id="element-1459">
                  <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1460">
                    ✓
                  </div>
                  <div data-id="element-1461">Structured learning plan with clear progression</div>
                </li>
              </ul>
            </div>
            <div data-id="element-1462">
              <h3 className="text-xl font-semibold mb-3" data-id="element-1463">Considerations</h3>
              <ul className="space-y-2" data-id="element-1464">
                <li className="flex" data-id="element-1465">
                  <div className="mr-4 text-amber-500" aria-hidden="true" data-id="element-1466">
                    !
                  </div>
                  <div data-id="element-1467">Requires commitment to a condensed schedule</div>
                </li>
                <li className="flex" data-id="element-1468">
                  <div className="mr-4 text-amber-500" aria-hidden="true" data-id="element-1469">
                    !
                  </div>
                  <div data-id="element-1470">Can be mentally and physically demanding</div>
                </li>
                <li className="flex" data-id="element-1471">
                  <div className="mr-4 text-amber-500" aria-hidden="true" data-id="element-1472">
                    !
                  </div>
                  <div data-id="element-1473">
                    Need to be available for multiple hours over consecutive
                    days
                  </div>
                </li>
                <li className="flex" data-id="element-1474">
                  <div className="mr-4 text-amber-500" aria-hidden="true" data-id="element-1475">
                    !
                  </div>
                  <div data-id="element-1476">
                    Best suited for those who can absorb information quickly
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mb-12" data-id="element-1477">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1478">
            How Our Intensive Courses Work
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1479">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1480">
              <h3 className="text-xl font-semibold mb-3" data-id="element-1481">1. Assessment</h3>
              <p className="text-gray-700" data-id="element-1482">
                We begin with an assessment of your current driving ability to
                tailor the course to your specific needs and determine the
                appropriate number of hours.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1483">
              <h3 className="text-xl font-semibold mb-3" data-id="element-1484">2. Scheduling</h3>
              <p className="text-gray-700" data-id="element-1485">
                We'll work with you to create a schedule that fits your
                availability, typically involving daily sessions of 2-4 hours
                over 1-2 weeks.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1486">
              <h3 className="text-xl font-semibold mb-3" data-id="element-1487">3. Completion</h3>
              <p className="text-gray-700" data-id="element-1488">
                The course concludes with a mock test to ensure you're fully
                prepared, followed by assistance in booking your practical
                driving test.
              </p>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-1489">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1490">
            Ready to Fast-Track Your Driving Journey?
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-1491">
            Contact us today to discuss our intensive courses and find the
            perfect option for your needs and schedule.
          </p>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book your intensive driving course in Northampton" data-id="element-1492">
            Enquire Now
          </a>
        </div>
      </div>
    </div>;
};
export default IntensiveLessonsPage;